import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./CSS/ShopCategory.css";
import { ShopContext } from "../Context/ShopContext";
import dropdown_icon from "../Components/Assets/dropdown_icon.png";
import Item from "../Components/Item/Item";
 
const ShopCategory = (props) => {
  const { all_product } = useContext(ShopContext);
  const { category, subcategory } = useParams();
  
  // Use params if available, otherwise fallback to props
  const currentCategory = category || props.category || "";
  const [selectedSubCategory, setSelectedSubCategory] = useState("All");

  // Initialize subcategory from URL when component mounts or params change
  useEffect(() => {
    if (subcategory) {
      setSelectedSubCategory(subcategory);
    } else {
      setSelectedSubCategory("All");
    }
  }, [subcategory]);

  // Get unique subcategories for the current category
  const subCategories = [
    "All",
    ...new Set(
      all_product
        .filter(item => item.category === currentCategory)
        .map(item => item.subCategory)
        .filter(sub => sub) // Filter out undefined/null subcategories
    )
  ];

  // Filter products based on selected category and subcategory
  const filteredProducts = all_product.filter(item => {
    const matchesCategory = item.category === currentCategory;
    const matchesSubCategory = 
      selectedSubCategory === "All" || 
      item.subCategory === selectedSubCategory;
    
    return matchesCategory && matchesSubCategory;
  });

  const handleSubCategoryChange = (e) => {
    const newSubCategory = e.target.value;
    setSelectedSubCategory(newSubCategory);
    // You might want to update the URL here if using navigation
  };

  return (
    <div className="shop-category">
      <div className="shopcategory-indexSort">
        <p >
          <span>Showing {filteredProducts.length}</span> products in {currentCategory}
          {selectedSubCategory !== "All" && ` > ${selectedSubCategory}`}
        </p>
        
        <div className="shopcategory-sort">
          <label htmlFor="subcategory-select">Filter by:</label>
          <select
            id="subcategory-select"
            value={selectedSubCategory}
            onChange={handleSubCategoryChange}
          >
            {subCategories.map((sub, index) => (
              <option key={index} value={sub}>
                {sub || "All"}
              </option>
            ))}
          </select>
          <img src={dropdown_icon} alt="dropdown" />
        </div>
      </div>

      <div className="shopcategory-products">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item) => (
            <Item
              key={item.id}
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          ))
        ) : (
          <p className="no-products-message">No products found in this category.</p>
        )}
      </div>
    </div>
  );
};

export default ShopCategory;